<template>
  <div>
    <v-container fluid class="bo-node-content">
      <meta-content :metaContentNodes="bonode"></meta-content>
      <headlinesLight category="BettingHeadlines" ></headlinesLight>
      <bo-navigation v-show="bonode && bonode.idfwbonavigation" class="child-navigation" :preselect-first-node="true" astabs="true"></bo-navigation>
      <div v-if="!isInPlayBoNode">
        <div class="tab-coupons">
          <div v-for="tabCoupon in tabCouponNodes" :key="tabCoupon.idfwbonavigation">
            <tab-coupon :tabcouponnode="tabCoupon"></tab-coupon>
          </div>
        </div>
        <div class="marketgroups" v-if="marketgroups && marketgroups.length > 0">
            <market-group v-for="mg in marketgroups"
                          :key="mg.idfwmarketgroup"
                          :idfwmarketgroup="mg.idfwmarketgroup"
                          :events-grouping="bonode.displaytemplatename"
                          :maxevents="bonode.maxitems || 0"></market-group>
        </div>
      </div>
      <div v-if="isInPlayBoNode">
        <live-coupon :ontab="true" :idfosporttypescsv="bonode.csvparameters || 'ALL'" :maxeventspersporttype="bonode.maxitems" :couponname="bonode.name"></live-coupon>
      </div>
    </v-container>
  </div>

</template>
<script>
  import MetaContent from '@/components/sports/bettingoffer/metaContent'
  import headlinesLight from '@/components/sports/bettingoffer/headlinesLight'
  import headlines from '@/components/sports/bettingoffer/headlines'
  import tabCoupon from '@/components/sports/bettingoffer/tabCoupon'
  import marketGroup from '@/components/sports/bettingoffer/marketGroup'
  import liveCoupon from '@/components/sports/bettingoffer/live/LiveCoupon'
  import BoNavigation from '@/components/sports/bettingoffer/BoNavigation'
  import BettingOffer from '@/components/mixins/BettingOffer'

  export default {
    name: 'bo-node-content',

    props: [
      'bonode'
    ],

    mixins: [
      BettingOffer
    ],

    components: {
      MetaContent,
      headlinesLight,
      tabCoupon,
      marketGroup,
      liveCoupon,
      BoNavigation,
      headlines
    },

    computed: {
      isInPlayBoNode () {
        return this.checkIsNodeNavigationType(this.bonode, 'INPLAYPERSPORTTYPE')
      },
      tabCouponNodes () {
        if (this.bonode && this.bonode.bonavigationnodes) {
          return this.bonode.bonavigationnodes.filter(item => this.checkIsNodeNavigationType(item, 'TABCONTAINER'))
        }
      },
      marketgroups () {
        if (this.bonode && this.bonode.marketgroups) {
          return this.bonode.marketgroups
        } else {
          return []
        }
      }
    },

    methods: {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/BoNodeContent.vue